import React from "react";
import cn from "../../lib/cn";
import P from "../../shared/typography/P";

const TableReport = ({ label, data, type, projectEnable }) => {
    return (
        <div className="bg-gray-100 p-2  rounded-xl min-w-[10rem]">
            <P className="text-secondary hidden md:block mb-2">{label}</P>
            <table className="w-full">
                <tbody>
                    {data?.map((item, index) => (
                        <tr
                            key={index}
                            className="flex justify-between items-center gap-5 my-1"
                        >
                            <td className="w-[45%]">
                                <div>
                                    <P
                                        className={cn(
                                            "md:text-base xl:text-base text-secondary",
                                            { "text-gray-130": !projectEnable }
                                        )}
                                    >
                                        {item.label}
                                    </P>
                                    <p
                                        className={cn(
                                            "text-xs text-secondary",
                                            { "text-gray-130": !projectEnable }
                                        )}
                                    >
                                        {item.subLabel}
                                    </p>
                                </div>
                            </td>

                            <td className="w-1/3">
                                <div className="flex flex-col justify-start items-end">
                                    <P
                                        className={cn(
                                            "font-bold xl:text-xl flex text-nowrap items-center gap-0.5",
                                            { "text-gray-130": !projectEnable }
                                        )}
                                    >
                                        {item.value} {item.icon}
                                    </P>
                                    <p className="text-end text-xs text-nowrap text-secondary">
                                        {item.unit}
                                    </p>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TableReport;
